import flFiltersInit from '../theme/fl-filters';
import StatistiquesGraphiqueCommandesInit from '../theme/fl-charts';

const { docReady } = window.phoenix.utils;

docReady(flFiltersInit);
docReady(StatistiquesGraphiqueCommandesInit);
